// extracted by mini-css-extract-plugin
module.exports = {"mediaItem":"mediaItem--2jWdg","tableCell":"tableCell--Y3znX","image":"image--355JZ","action":"action--2Bp9O","deleteButton":"deleteButton--3AlSW"};